import '@lokalise/token-dictionary/css/theme-lokalise-light.css';
import '@lokalise/token-dictionary/css/theme-lokalise-dark.css';
import '@lokalise/louis/style.css';

import { ThemeProvider as LouisThemeProvider } from '@lokalise/louis';
import { StyleSheetManager } from '@lokalise/styled';
import type { FunctionComponent } from 'react';

import { themes } from '@app/theme';

import type { Props } from './types';

const ThemeProvider: FunctionComponent<Props> = ({ isDarkmode, children }: Props) => (
    <StyleSheetManager enableVendorPrefixes>
        <LouisThemeProvider theme={isDarkmode ? themes.darkTheme : themes.baseTheme}>
            {/* themeProvider to have option to select this element outside react scope */}
            <div data-type="themeProvider" data-theme={isDarkmode ? 'lokalise-dark' : 'lokalise-light'}>
                {children}
            </div>
        </LouisThemeProvider>
    </StyleSheetManager>
);

export default ThemeProvider;
